import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button, Row, Col, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import 'react-block-ui/style.css';

class NewEmail extends Component {

    render() {
        
        var ls = JSON.parse(localStorage.getItem("fc-logged"));
        var rcu = localStorage.getItem("faRCUser");
        var rcp = localStorage.getItem("faRCPwd");
        var roundcubeUrl = localStorage.getItem("faRC");

        var url = `${roundcubeUrl}?user=${rcu}&pass=${rcp}&tenant=${ls.tenantName}&_task=mail&_action=compose&_extwin=1&_agentId=${this.props.userId}&_faagtinbox=1`

        return (
            <Modal show={this.props.show} onHide={this.props.toggleModal} onShow={this.showModal} size="lg">
                <Modal.Header >
                    <Modal.Title><FontAwesomeIcon icon={duotone("envelope")} /> {this.props.t("newemail")}</Modal.Title>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {this.props.t("close")}
                        </Tooltip>}>
                        <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                    </OverlayTrigger>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <iframe src={url} width="100%" height="720px" title="newmail"></iframe>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        userId: state.agent.userId
    };
};

export default compose(connect(mapStateToProps, {}), withTranslation())(NewEmail);